const fixCartChange = ()=>{
   let timeout;
    const targetNode = document.querySelector('#mini-cart-drawer, #main-cart-items');
    const config = { attributes: true };
    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.attributeName === 'class') {
                clearTimeout(timeout)
                timeout = setTimeout(() => {
                    if (BSS_B2B.isAppliedCheckoutBSS === true) {
                      $("button[name='checkout'], #checkout").css({"display": "none"})
                      $("#bss-checkout").css({"display": "block"})
                    }
                    BSS_B2B.cart.fixer(JSON.parse($('#bss-b2b-store-data').html()), false, false);
                }, 100);
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}
 const fixVariantQuickView = () => {
    const variantQuickViewBtns = $(".t4s-swatch__item[data-swatch-item]");
      variantQuickViewBtns.each((idx,variantQuickViewBtn)=>{
        $(variantQuickViewBtn).click(()=>{
            BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false)
        })
      })
  }
  const fixQuickView = () =>{
    let interval
    interval = setInterval(()=>{
      const quickViewBtns = $("quick-view-modal > button");
      if(quickViewBtns.length > 0){
        clearInterval(interval)
        quickViewBtns.each((idx,quickViewBtn)=>{
          $(quickViewBtn).click(()=>{
             setTimeout(()=>{
                BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false);
                // fixVariantQuickView()
             },1000)
          })
        })
      }
    },200)
    setTimeout(()=> clearInterval(interval), 4000);
  }
if (typeof BSS_B2B !== 'undefined') {
   fixCartChange();
   fixQuickView();
}
